/**
 * @desc 根据ID查询具体物料信息
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {
  /** id */
  id: number;
}

export function request(
  params: Params,
): Promise<defs.StandardReturn<defs.MaterialInfoDTO>> {
  return defHttp.get({
    url: '/web/material/queryById',

    params,
  });
}

export function mock(
  params: Params,
): Promise<defs.StandardReturn<defs.MaterialInfoDTO>> {
  return defHttp.get({
    url: '/mock/web/material/queryById',

    params,
  });
}
